// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-enter[data-v-bc1e7658] {\n  opacity: 0;\n}\n.modal-leave-active[data-v-bc1e7658] {\n  opacity: 0;\n}\n.modal-enter .modal-container[data-v-bc1e7658],\n.modal-leave-active .modal-container[data-v-bc1e7658] {\n  transform: scale(1.1);\n}\n", ""]);
// Exports
module.exports = exports;
